import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import useSearchQueryFilter from 'dpl/breeder_search_results/hooks/useSearchQueryFilter';
import Checkbox from 'dpl/common/design_system/Checkbox';
import { FILTER_PARAMS } from 'dpl/puppy_search_results/utils/constants';
import TooltipWrapper from 'dpl/common/tooltip/components/TooltipWrapper';
import Icon from 'dpl/common/components/Icon';
import { TOOLTIP_VARIANTS } from 'dpl/common/utils/constants';

/** @param {any} props */
export default function MultiSelectChecklistFilter({
  filterTitle = null,
  filterSubtitle = null,
  filterParam,
  filterOptions,
  filterTooltipText = null
}) {
  const { searchQueryFilterValues, toggleFilter } =
    useSearchQueryFilter(filterParam);

  return (
    <>
      {Boolean(filterTitle) && (
        <div className="mb6">
          <div className="flex items-center">
            <h4 className="font-20 lh-title">{filterTitle}</h4>
            {filterTooltipText && (
              <TooltipWrapper
                data-test-id="filter-tooltip"
                title={filterTooltipText}
                minWidth="250px"
                className="z-max"
                variant={TOOLTIP_VARIANTS.STONE}
                tooltipTextClassName="pt15"
                disablePositionReset
              >
                <Icon
                  name="fetch-question"
                  width="20"
                  height="20"
                  className="ml2 secondary"
                />
              </TooltipWrapper>
            )}
          </div>
          {filterSubtitle && (
            <p className="font-14 secondary mt2 w-100 w-80-md">
              {filterSubtitle}
            </p>
          )}
        </div>
      )}
      <ul className="flex flex-column gap-16">
        {filterOptions.map(
          ({
            title,
            value,
            long_description: longDescription,
            short_description: shortDescription
          }) => (
            <li
              key={value}
              className={classnames(
                `SearchResultFilters${filterTitle || ''}Filter`
              )}
            >
              <Checkbox
                key={value}
                id={`${filterParam}_${value}`}
                name={title}
                value={value}
                label={title}
                shortDescription={shortDescription}
                longDescription={longDescription}
                checked={searchQueryFilterValues.includes(Number(value))}
                onChange={e => toggleFilter(Number(e.target.value))}
              />
            </li>
          )
        )}
      </ul>
    </>
  );
}

MultiSelectChecklistFilter.propTypes = {
  filterTitle: PropTypes.string,
  filterSubtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  filterParam: PropTypes.oneOf(FILTER_PARAMS).isRequired,
  filterOptions: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    })
  ).isRequired,
  filterTooltipText: PropTypes.string
};
